/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import {
  HOME_PAGE_CATEGORY,
  HOME_PAGE_SCREEN_NAME,
  HomePageParams,
  HomePageEvents,
  HOME_PAGE_LABEL,
} from './homepage.meta';

const BASE_HOME_PARAMS = {
  screenName: HOME_PAGE_SCREEN_NAME.home,
  screen_name: HOME_PAGE_SCREEN_NAME.home,
};

const UHF_PARAMS = {
  ...BASE_HOME_PARAMS,
  category: HOME_PAGE_CATEGORY.uhf,
  action: HomePageEvents.tap,
};
const PRODUCT_TILES_PARAMS = {
  ...BASE_HOME_PARAMS,
  category: HOME_PAGE_CATEGORY.homepage_product_tiles,
};
const SEARCH_TAB_PARAMS = {
  ...BASE_HOME_PARAMS,
  category: HOME_PAGE_CATEGORY.homepage_search_tab,
  action: HomePageEvents.tap,
};
const NOTIFICATION_BANNER_PARAMS = {
  ...BASE_HOME_PARAMS,
  category: HOME_PAGE_CATEGORY.homepage_notification_banner,
};

export default {
  // UHF Header Actions
  [HomePageEvents.Profile_Click]: () => ({
    ...UHF_PARAMS,
    label: HOME_PAGE_LABEL.profile,
  }),
  [HomePageEvents.Wallet_Click]: () => ({
    ...UHF_PARAMS,
    label: HOME_PAGE_LABEL.wallet,
  }),
  [HomePageEvents.Search_Click]: () => ({
    ...UHF_PARAMS,
    label: HOME_PAGE_LABEL.search,
  }),

  // Product Tiles
  [HomePageEvents.Product_Tiles_Viewed]: (params: HomePageParams) => ({
    ...PRODUCT_TILES_PARAMS,
    label: params.label ?? '',
    action: HomePageEvents.view,
  }),
  [HomePageEvents.Product_Tile_Click]: (params: HomePageParams) => ({
    ...PRODUCT_TILES_PARAMS,
    label: params.label,
    action: HomePageEvents.tap,
  }),
  [HomePageEvents.Search_Tab_Click]: (params: HomePageParams) => ({
    ...SEARCH_TAB_PARAMS,
    label: params.label,
  }),

  // Notification Banner
  [HomePageEvents.Notification_Banner_Viewed]: (params: HomePageParams) => ({
    ...NOTIFICATION_BANNER_PARAMS,
    label: params.label,
    action: HomePageEvents.view,
  }),
  [HomePageEvents.Notification_Banner_Clicked]: (params: HomePageParams) => ({
    ...NOTIFICATION_BANNER_PARAMS,
    label: params.label,
    action: HomePageEvents.tap,
  }),
  [HomePageEvents.Hero_Banner_Viewed]: (params: HomePageParams) => ({
    ...BASE_HOME_PARAMS,
    category: HOME_PAGE_CATEGORY.homepage_hero_banner,
    label: params.label,
    action: HomePageEvents.view,
  }),
  [HomePageEvents.Hero_Banner_Clicked]: (params: HomePageParams) => ({
    ...BASE_HOME_PARAMS,
    category: HOME_PAGE_CATEGORY.homepage_hero_banner,
    label: params.label,
    action: HomePageEvents.tap,
  }),
  [HomePageEvents.Article_Carousel_Viewed]: (params: HomePageParams) => ({
    ...BASE_HOME_PARAMS,
    category: `${HOME_PAGE_CATEGORY.homepage_article_carousel}|${params.sectionTitle ?? ''}`,
    label: params.label,
    action: HomePageEvents.view,
  }),
  [HomePageEvents.Article_Carousel_Clicked]: (params: HomePageParams) => ({
    ...BASE_HOME_PARAMS,
    category: `${HOME_PAGE_CATEGORY.homepage_article_carousel}|${params.sectionTitle ?? ''}`,
    label: params.label,
    action: HomePageEvents.tap,
  }),
  [HomePageEvents.Recommendation_Show_More_Clicked]: (
    params: HomePageParams,
  ) => ({
    ...BASE_HOME_PARAMS,
    category: HOME_PAGE_CATEGORY.homepage_recommendation_tab,
    label: `showMore|${params.tabName ?? ''}|${params.quartile ?? 0}|${params.maxIndex ?? 0}`,
    action: HomePageEvents.tap,
  }),
};
